<template>
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.54639 1.95288L10.8272 11.2337"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M1.54639 11.2336L10.8272 1.95287"
      stroke="currentColor"
      stroke-width="1.5"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconClose'
}
</script>
